import routes from '@modules/game/game-routes';
import store from '@modules/game/game-store';

export default {
  routes,
  store,
};
